import React from 'react';
import { Box, ButtonV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { TextV2 } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';

interface EmptyStateProps {
  onReset?: () => void;
  showResetButton?: boolean;
}

export const EmptyState = ({ onReset, showResetButton }: EmptyStateProps) => {
  const { t } = useTranslation('accommodationsConsole');
  const emptyStateTrans = t('emptyState');
  return (
    <Box paddingX={pxToRem(24)} paddingY={pxToRem(40)}>
      <TextV2 typographyVariant={'hed5'}>{emptyStateTrans.title()}</TextV2>
      <TextV2 typographyVariant={'body2'} marginTop={5} color={'mono10'}>
        {emptyStateTrans.content()}
      </TextV2>
      {showResetButton && (
        <ButtonV2 shape="rounded" intent="neutral" typographyVariant={'button2'} variant="outline" marginTop={6} onClick={onReset}>
          {emptyStateTrans.buttonText()}
        </ButtonV2>
      )}
    </Box>
  );
};
